import { useEffect, useRef, useState } from "react";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";
import { MdLocationOn } from "react-icons/md";
import Layout from "../../Layout";
import DrugServices from "../../Services/DrugServices";
import LocationService from "../../Services/LocationService";
import { Flex, message, Spin } from "antd";
import { convertUTCDate } from "../../utils/convertionFunc";
import MedicineCard from "./medicineCard";
import nodatafound from "../../assets/images/Svg/nodatafound.svg";
import { useSelector } from "react-redux";
import PaginationMed from "./PaginationMed";
const itemsPerPage = 12;

function BookMedicines() {
  const [medicines, setMedicines] = useState([]);
  const [loader, setLoader] = useState(false);
  const [searchVal, setSearchVal] = useState("");
  const [showDropdown, setShowDropdown] = useState(false);
  const [price, setPrice] = useState(500);
  const [currentPage, setCurrentPage] = useState(1);
  const [currPageMed, setCurrPageMed] = useState([]);
  const dropdownRef = useRef(null);
  const inputRef = useRef(null);
  const totalPages = Math.ceil(medicines?.length / itemsPerPage);
  const paginatedMedicines = medicines
    ? medicines.slice(
        (currentPage - 1) * itemsPerPage,
        currentPage * itemsPerPage
      )
    : [];
  const [selectedAddress, setSelectedAddress] = useState();
  const [showAddressForm, setShowAddressForm] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [addresses, setAddresses] = useState([]);
  const [loading, setLoading] = useState(false);
  const [availPinCode, setAvailPincode] = useState("");
  const [formData, setFormData] = useState({
    address1: "",
    address2: "",
    city: "",
    country: "",
    mobile: "",
    pinCode: "",
    state: "",
  });
  const [selected, setSelected] = useState();
  const [deliverable, setDeliverable] = useState("");
  const { patientData } = useSelector((state) => state.auth);

  useEffect(() => {
    fetchMedicines(searchVal);
    if (patientData && patientData?.patientId) {
      getPatientAddresses();
      const pin = patientData?.pinCode;
      if (pin) {
        setAvailPincode(pin);
        checkAvailability(pin);
      }
    }
  }, [patientData]);

  useEffect(() => {
    if (medicines.length > 0) {
      const paginatedMedicines = medicines.slice(
        (currentPage - 1) * itemsPerPage,
        currentPage * itemsPerPage
      );
      setCurrPageMed(paginatedMedicines);
    }
  }, [medicines, currentPage]);

  const [address, setAddress] = useState(null);

  const fetchPatientAddress = async () => {
    let payload = {
      patientId: patientData?.patientId,
      defaultAddressYN: "Y",
      status: 1,
    };

    try {
      setLoading(true);
      let result = await LocationService.getPatientAddress(payload);
      if (result.data.length > 0) {
        setAddress(result?.data?.[0] || null);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (patientData && patientData?.patientId) {
      fetchPatientAddress();
    }
  }, [patientData]);

  useEffect(() => {
    document.addEventListener("click", handleClickOutside);
    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, []);

  const handleClickOutside = (e) => {
    if (
      dropdownRef.current &&
      !dropdownRef.current.contains(e.target) &&
      inputRef.current !== e.target
    ) {
      setShowDropdown(false);
    }
  };

  const fetchMedicines = async (searchVal, pageNo = 1) => {
    setLoader(true);
    setCurrentPage(pageNo);

    try {
      const response = await DrugServices.fetchDrugList(searchVal, pageNo);
      if (response?.data?.data && response?.data?.data?.length !== 0) {
        setMedicines(response?.data?.data);
        setLoader(false);
      }
    } catch (e) {
      setLoader(false);
      console.error(e);
    }
  };

  const handlePageChange = (newPage) => {
    if (newPage > 0 && newPage <= totalPages) {
      setCurrentPage(newPage);
    }
  };

  const handleSearch = (e) => {
    setSearchVal(e.target.value);
    if (e.target.value && e.target.value.length >= 3) {
      fetchMedicines(e.target.value);
      setShowDropdown(true);
    } else if (!e.target.value) {
      fetchMedicines("");
      setShowDropdown(false);
    }
  };

  const handleSelectMed = (item) => {
    setMedicines([item]);
    setShowDropdown(false);
  };

  const getPatientAddresses = async () => {
    let payload = {
      patientId: patientData?.patientId,
      status: 1,
    };

    try {
      setLoading(true);
      let result = await LocationService.getPatientAddress(payload);
      if (result.data.length > 0) {
        setAddresses(result.data);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleAddressSave = async () => {
    const isFormEmpty = Object.values(formData).every(
      (value) => value.trim() === ""
    );

    if (isFormEmpty) {
      message.error("Please enter values in the form");
      return;
    }

    let payload = {
      account_Id: patientData?.account_Id,
      clinic_Id: patientData?.clinic_Id,
      createdBy: patientData?.patientId,
      modifiedBy: patientData?.patientId,
      patientId: patientData?.patientId,
      defaultAddressYN: "N",
      status: 1,
      createdDate: convertUTCDate(new Date(), "YYYY-MM-DD HH:mm:ss"),
      modifiedDate: convertUTCDate(new Date(), "YYYY-MM-DD HH:mm:ss"),
      ...formData,
    };
    try {
      setLoading(true);
      let saveResult = LocationService.savePatientAddress(payload);
      // getPatientAddresses();
      setShowAddressForm(false);
      setLoading(false);
    } catch (error) {
      console.error(error);
    } finally {
    }
  };

  const handleSelectedAddress = (address, index) => {
    setSelectedAddress(address);
    setSelected(index);
    setAvailPincode(address?.pinCode);
  };

  const checkAvail = (e) => {
    const pincode = e.target.value;
    setAvailPincode(pincode);

    if (pincode.length === 6) {
      checkAvailability(pincode);
    }
  };

  const checkAvailability = async (pincode) => {
    if (!pincode || pincode.length !== 6) return;

    let payload = {
      pincode,
      status: 1,
    };

    try {
      let result = await LocationService.checkAvailability(payload);

      if (result.data.length > 0) {
        setDeliverable(pincode);

        if (selectedAddress?.pinCode === pincode) {
          let defaultPayload = {
            defaultAddressYN: "Y",
            id: selectedAddress.id,
            patientId: selectedAddress.patientId,
          };
          await LocationService.setDefaultAddress(defaultPayload);
        }

        setShowModal(false);
      } else {
        message.error(
          "Service is not available in this area, choose another area"
        );
      }
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <Layout>
      <div className="p-5">
        <div className="flex gap-2 items-center">
          <h3 className="text-[#189FAA] font-sans font-semibold text-sm">
            Book Medicine
          </h3>
          <p>/</p>
          <h3 className="font-sans font-semibold text-sm">Medicines</h3>
        </div>
        <div className="w-full">
          <div className="flex justify-center gap-3 mt-3">
            <div className="flex items-center border rounded-md px-3 py-1">
              <MdLocationOn className="text-[#189FAA] text-lg mr-2" />
              <input
                type="text"
                placeholder="Enter Pincode"
                onChange={checkAvail}
                value={availPinCode}
                className="text-sm font-sans font-medium outline-none placeholder:text-xs w-full"
              />
            </div>
            <div class="relative w-[480px] rounded-md border p-1">
              <input
                type="text"
                class="w-full pl-8 pr-24 py-1 font-sans font-medium text-sm placeholder:text-xs text-gray-700 bg-transparent rounded-md focus:outline-none"
                placeholder="Search medicine"
                onChange={handleSearch}
              />
              <button class="absolute right-1 top-1 bottom-1 px-6 bg-[#189FAA] text-white font-sans text-sm font-medium rounded-md focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#5044e4]">
                Search
              </button>
              {showDropdown && (
                <div
                  ref={dropdownRef}
                  className="absolute z-40 top-full left-0 w-full bg-white h-[300px] overflow-auto scrollWidth shadow-lg rounded-lg p-1 mt-1"
                >
                  <ul>
                    {medicines?.map((med) => (
                      <li
                        onClick={() => handleSelectMed(med)}
                        key={med.code}
                        className="p-2 hover:bg-gray-200 cursor-pointer"
                      >
                        {med.medicineName}
                      </li>
                    ))}
                  </ul>
                </div>
              )}
            </div>
          </div>
        </div>
        <div className="flex gap-5 mt-7">
          <div className="mx-auto w-[82%]">
            <div className="flex justify-between m-2">
              <p className="text-[#333333] font-sans text-sm font-semibold">
                Medicines
              </p>
              <div className="flex gap-3 items-center">
                <p className="text-gray-400 font-sans font-semibold text-sm">
                  Sort by
                </p>
                <div>
                  <select
                    id="speciality"
                    class="block w-full font-sans font-medium cursor-pointer px-4 py-1.5 text-sm text-gray-700 bg-white border border-gray-300 rounded-md shadow-sm outline-none "
                  >
                    <option disabled selected>
                      Relevance
                    </option>
                  </select>
                </div>
              </div>
            </div>
            {loader && medicines?.length === 0 ? (
              <div className="w-full h-[300px] flex items-center justify-center">
                <Flex align="center" gap="middle">
                  <Spin size="large" tip="Loading" />
                </Flex>
              </div>
            ) : !loader && medicines?.length === 0 ? (
              <div className="flex flex-col items-center justify-center">
                <img
                  src={nodatafound}
                  alt="nodatafound"
                  className="h-min w-min"
                />
                <p className="font-medium text-xl">No data found!!</p>
              </div>
            ) : (
              <div className="grid grid-cols-4 md:grid-cols-3 lg:grid-cols-4 gap-4">
                {currPageMed.map((medicine) => (
                  <MedicineCard
                    medicine={medicine}
                    deliverable={deliverable}
                    address={address}
                  />
                ))}
              </div>
            )}
          </div>
        </div>
        <div className="h-[49px] w-full border rounded-md flex justify-between items-center p-5 mt-3">
          <p className="text-sm font-sans font-normal text-[#333333]">
            {/* Showing 1 to 12 of 20 */}
          </p>

          {/* <PaginationMed
            currentPage={currentPage}
            totalPages={2}
            goToPage={fetchMedicines}
          /> */}
          <div className="flex items-center justify-center space-x-2">
            <button className="p-2 rounded-md text-gray-700 bg-white">
              <FaChevronLeft className="text-[#189FAA]" />
            </button>

            <button
              onClick={() => handlePageChange(1)}
              className={`px-3 py-1 rounded-md ${
                currentPage == 1
                  ? "bg-teal-500 text-white"
                  : "bg-white text-gray-700"
              }   text-sm border`}
            >
              1
            </button>
            <button
              onClick={() => handlePageChange(2)}
              className={`px-3 py-1 rounded-md ${
                currentPage == 2
                  ? "bg-teal-500 text-white"
                  : "bg-white text-gray-700"
              }   text-sm border`}
            >
              2
            </button>
            <button
              onClick={() => handlePageChange(3)}
              className={`px-3 py-1 rounded-md ${
                currentPage == 3
                  ? "bg-teal-500 text-white"
                  : "bg-white text-gray-700"
              }   text-sm border`}
            >
              3
            </button>
            <button
              onClick={() => handlePageChange(4)}
              className={`px-3 py-1 rounded-md ${
                currentPage == 4
                  ? "bg-teal-500 text-white"
                  : "bg-white text-gray-700"
              }   text-sm border`}
            >
              4
            </button>

            <button className="p-2 rounded-md text-gray-700 bg-white">
              <FaChevronRight className="text-[#189FAA]" />
            </button>
          </div>
        </div>
      </div>
    </Layout>
  );
}

export default BookMedicines;
